import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { IEmployeesFilterParams, OptionType } from '../EmployeesComboboxMI';
import { createGridConfig, IGridResourcesConfig } from './GridResourcesConfig';
import { IResourceInputConfig } from './Models';
import MultiEmployeesForm from './MultiEmployeesForm';
import lang from './RelationsLang';

export const defaultEmployeeGrid: IGridResourcesConfig = {
	title: lang.selectEmployee(),
	hidden: false,
	columns: [
		{ id: "name", label: lang.name(), minWidth: 210, searched: true, numeric: false },
		{ id: "type", label: lang.type(), searched: false, numeric: false },
		{ id: "hrId", label: lang.hrId(), minWidth: 70, searched: true, numeric: false },
		{ id: "sapId", label: lang.sapId(), minWidth: 70, searched: true, numeric: false },
		{ id: "status", label: lang.status(), searched: true, numeric: false },
		{ id: "city", label: lang.city(), searched: false, numeric: false },
		{ id: "company", label: lang.company(), searched: false, numeric: false },
		{ id: "department", label: lang.department(), searched: false, numeric: false },
	],
	filters: "",
	rowsPerPageOptions: [10, 50, 100],
}

interface IRenderEmployeeInputProps {
	name: string,
	label: string,
	config: IResourceInputConfig,
	employeesError: string,
	blockChangeEmployees: boolean,
	employeesFilters: IEmployeesFilterParams,

	onChange: (v: OptionType[]) => void,
	value: OptionType[]
	getButtons?: (employee: OptionType) => JSX.Element,
}

export function RenderMultiEmployeesInput(props: IRenderEmployeeInputProps) {

	const { t } = useTranslation();
	if (props.config.hidden) {
		return null;
	}

	const grid = createGridConfig("selectEmployee", props.config.grid, defaultEmployeeGrid);
	const name = lang.getDefaultByPrefix(props.config, "label", props.name);
	const label = lang.getDefaultByPrefix(props.config, "label", props.name);

	return (<div className="flex-form-field form-field-access-for">
		<div className="flex-field-label">
			<label>{name}:</label>
		</div>
		<div className="flex-field-input">
			<p className="text-danger">
				{t(props.employeesError, { label: label })}
			</p>
			<MultiEmployeesForm
				blockChangeEmployees={props.blockChangeEmployees}
				employeesFilters={props.employeesFilters}
				value={props.value}
				onChange={props.onChange}
				multiple={props.config.multiple}
				placeholderText={lang.getDefaultByPrefix(props.config, "placeholder")}
				getButtons={props.getButtons}
				grid={grid}
			/>
		</div>
	</div>);
}
